import React from "react";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "app/components/BreadCrumb";
import { useTranslation } from "react-i18next";
import { useInjectReducer } from "redux-injectors";
import { AddButton } from "app/components/Button/AddButton";
import { adminCatalogActions, reducer, sliceKey } from "./redux/slice";

import { useStyles } from "./styles";
import AdminCatalogTable from "./components/CatalogTable";
import AddCatalogModal from "./components/AddCatalogModal";
import { selectCatalogs, selectIsLoading } from "./redux/selector";

const AdminCatalog = () => {
  const styles = useStyles();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const rows = useSelector(selectCatalogs);
  const loading = useSelector(selectIsLoading);

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb title={t("SIDEBAR.CATALOGS")} iconPosition="end" />
          <Box>
            <AddButton
              label={t("CATALOGS.ADD")}
              onClick={() => dispatch(adminCatalogActions.openAddModal())}
            />
          </Box>
          <AdminCatalogTable rows={rows} loading={loading} />
        </Box>
      </Box>
      <AddCatalogModal />
    </Box>
  );
};

export default AdminCatalog;
